module.exports = __webpack_public_path__ + "img/logo.bbe43850.svg";